import { render, staticRenderFns } from "./TingkatPendidikan.vue?vue&type=template&id=239bbc93"
import script from "./TingkatPendidikan.vue?vue&type=script&lang=js"
export * from "./TingkatPendidikan.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports